<script>
  import resources from './resources'
  export default {
    name: 'overview',
    mixins: [resources]
  }
</script>

<template lang="pug">
  .card
    .header
      h2
        strong Publicações
    .body.m-b-10(v-if="user.type === 'syndicate'")
      .form-group
        textarea.form-control.no-resize(rows='4', placeholder='Please type what you want...')
      .post-toolbar-b
        button.btn.btn-warning.btn-icon.btn-icon-mini.btn-round
          i.zmdi.zmdi-attachment
        button.btn.btn-warning.btn-icon.btn-icon-mini.btn-round
          i.zmdi.zmdi-camera
        button.btn.btn-primary.btn-round Postar
    .body(v-for="feed in feeds", style="margin-bottom: 10px;")
      .post-img
        img.img-fluid(src='https://backup-clients.sfo2.digitaloceanspaces.com/condomum/img/scheduled.png', alt='' witd)
      h5.m-t-20.m-b-0.post_title
        strong {{ feed.title}}
      p(v-html="feed.content")
      .form-group.m-b-0
        //-button.btn.btn-info.btn-round Like 5
        span.date.m-l-20
          i.zmdi.zmdi-alarm &nbsp;
          | {{ realTime(feed.created)}}
</template>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/app/dweller/profile/me/components/overview/components/feed/feed.vue